module.exports = __webpack_public_path__ + "static/media/468x60_0073_en.53a54c6b.jpg";